import WhatIsVaroAdvance from 'features/advance/screens/manageAdvanceAccount/WhatIsVaroAdvance/WhatIsVaroAdvance';
import React from 'react';

export default function WhatIsVaroAdvancePage() {
  return <WhatIsVaroAdvance />;
}
